module.exports = __webpack_public_path__ + "img/search-header-with-nav-nissan.72019563.png";